import React from 'react';
import {Modal, Input} from 'antd';

export default function DiagramNameModal({mode, open, name, onNameChange, onOk, onCancel}) {
	return (
		<Modal
			title={mode === 'create' ? 'Новая диаграмма' : 'Изменить название'}
			open={open}
			onOk={onOk}
			onCancel={onCancel}
			okText={mode === 'create' ? 'Создать' : 'Сохранить'}
			destroyOnHidden
		>
			<div style={{padding: '8px 0'}}>
				<Input
					placeholder="Название диаграммы"
					value={name}
					onChange={e => onNameChange(e.target.value)}
					onPressEnter={onOk}
					autoFocus
				/>
			</div>
		</Modal>
	);
}
